export default {
    state: {
        notes: {
            headers: [
                { text: 'Student ID', align: 'center', sortable: false, value: 'user_id' },
                { text: 'Student Email', align: 'center', sortable: false, value: 'email' },
                { text: 'Student Name', align: 'center', sortable: false, value: 'student_name' },
                { text: 'Course', align: 'center', sortable: false, value: 'course_name' },
                { text: 'Module', align: 'center', sortable: false, value: 'module' },
                { text: 'Question', align: 'center', sortable: false, value: 'question_title' },
                { text: 'Type', align: 'center', sortable: false, value: 'type' },
                // { text: 'Interaction Number', align: 'center', sortable: false, value: 'interaction_number' },
                { text: 'Response', align: 'center', sortable: false, value: 'student_response' },
                { text: 'Result', align: 'center', sortable: false, value: 'result' },
                // { text: 'Interaction Date', align: 'center', sortable: false, value: 'interaction_date' },
                // { text: 'Interaction Time', align: 'center', sortable: false, value: 'interaction_time' },
                { text: 'Last Modified', align: 'center', sortable: false, value: 'modified_time' },
                { text: 'Created Time', align: 'center', sortable: false, value: 'created_time' },
            ],
            records: []
        },
        editCreditNote:null,
        status:['Purchased Unit', 'Leased Unit', 'Unit Removed','Transfer Unit','Not Recovered','Credit Only','Amber','Purchased Not Removed','Transferred and Billed','Removed Unit','Purchased Unit Removed',]
    },
    getters: {


    },
    mutations: {
        setInteractions (state, data){
            state.notes.records = data;
            state.status.sort();
        }
    },
    actions: {
        setInteractions ({commit}, data){
            commit('setInteractions', data)
        }
    }
}